import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import store,{ RootState } from './reducers'

export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
